/** @jsxImportSource @emotion/react */

import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiSpacer,
  EuiTitle,
} from "@inscopix/ideas-eui";
import "ag-grid-enterprise";
import { CallOutError } from "components/CallOutError/CallOutError";
import { ParametersViewer } from "./ParametersViewer";
import { ResultsViewer } from "./ResultsViewer";
import { ToolDetails } from "pages/tool/PageToolQuery";
import { isToolSpecV2 } from "types/json-schemas/type_guards";

export const ToolSpecViewer = ({
  version,
}: {
  version: ToolDetails["versions"][number];
}) => {
  const toolSpec = version.tool_spec;
  if (isToolSpecV2(toolSpec) || toolSpec === null) {
    return <CallOutError />;
  }

  const params = toolSpec.params;
  const results = toolSpec.results;
  if (params === undefined || results === undefined) {
    return <CallOutError />;
  }

  return (
    <EuiFlexGroup direction="column" gutterSize="s">
      <EuiFlexItem grow={false} css={{ height: 40 }}>
        <EuiTitle size="s">
          <h3>Parameters</h3>
        </EuiTitle>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <ParametersViewer rowData={params} />
      </EuiFlexItem>
      <EuiSpacer size="xs" />
      <EuiFlexItem grow={false} css={{ height: 40 }}>
        <EuiFlexGroup alignItems="center">
          <EuiFlexItem grow={false}>
            <EuiTitle size="s">
              <h3>Outputs</h3>
            </EuiTitle>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <ResultsViewer rowData={results} />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
